<template>
  <div v-if="category && category.disabled_at" class="row">
    <div class="col-sm-12">
      <div class="alert alert-danger" role="alert">
        <span>This Tag Category is disabled</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ category: Record<string, any> }>();
</script>
